import { Box, Button, Flex, Select } from '@mantine/core';
import { TIME_UNITS, TimeUnit } from '../hooks/useLicenseStats';
import { useKnownApps } from '../hooks/useKnownApps';
import { DateTimePicker } from '@mantine/dates';
import { IconRefresh } from '@tabler/icons-react';

export type LicenseLogFilterDetails = {
  dateRange: [Date | null, Date | null];
  granularity: TimeUnit | null;
  app: string | null;
  forceRefresh: number;
  cursor: string | null;
};

export type LicenseLogFiltersProps = {
  filters: LicenseLogFilterDetails;
  onChange: (filters: LicenseLogFilterDetails) => void;
  showGranularity: boolean;
};

export const LicenseLogFilters = ({
  filters,
  onChange,
  showGranularity,
}: LicenseLogFiltersProps) => {
  const { knownApps } = useKnownApps();

  const refresh = () => {
    onChange({
      ...filters,
      forceRefresh: filters.forceRefresh + 1,
      cursor: null,
    });
  };
  return (
    <Box>
      <Flex gap="md" mb="lg" miw="100%">
        <DateTimePicker
          value={filters.dateRange[0]}
          onChange={(v) =>
            onChange({
              ...filters,
              cursor: null,
              dateRange: [v, filters.dateRange[1]],
            })
          }
          label="Date / Time from"
          clearable
          miw={200}
        />
        <DateTimePicker
          value={filters.dateRange[1]}
          onChange={(v) =>
            onChange({
              ...filters,
              cursor: null,
              dateRange: [filters.dateRange[0], v],
            })
          }
          label="Date / Time to"
          clearable
          miw={200}
        />
        {knownApps?.length ? (
          <Select
            data={knownApps}
            value={filters.app}
            label="Filter by application"
            onChange={(v) => onChange({ ...filters, cursor: null, app: v })}
          />
        ) : null}
        {showGranularity ? (
          <Select
            label="Time Granularity"
            data={TIME_UNITS}
            value={filters.granularity}
            onChange={(v) =>
              v
                ? onChange({
                    ...filters,
                    cursor: null,
                    granularity: v as TimeUnit,
                  })
                : null
            }
          />
        ) : null}
        <Button
          onClick={refresh}
          style={{ alignSelf: 'flex-end', marginLeft: 'auto' }}
          leftSection={<IconRefresh />}
          color="teal"
        >
          Refresh
        </Button>
      </Flex>
    </Box>
  );
};
